import { Component, ViewChild } from '@angular/core'
import { ResourceGroupsComponent } from 'app/shared/components/resource-groups'
import { ResourceType } from '@mprep/shared/data/models'

@Component({
  selector: 'mp-video-resources',
  templateUrl: './video-resources.html',
  styleUrls: ['./video-resources.scss']
})
export class VideoResourcesComponent {
  @ViewChild(ResourceGroupsComponent)
  resourceGroupsComponent: ResourceGroupsComponent
  
  constructor() {}
  
  public get videoResourceType() {
    return ResourceType.Video
  }
}



// WEBPACK FOOTER //
// ./src/app/video-resources/video-resources.component.ts